module.exports = __webpack_public_path__ + "static/media/big-himark.60ca415b.png";